export default __webpack_public_path__ + "static/media/sales_qrcode.0398346d.jpg";